import { VideoSection } from '@kinomap-dev/ng-ui-lib';

export class VideoState {
  videos: VideoSection[] = [];
  isLoadingVideos: boolean = false;
  areVideosComplete: boolean = false;
  homeVideos: VideoSection[] = [];
  videosOfTheWeek: VideoSection[] = [];
  recommendedVideos: VideoSection[] = [];
  top10Videos: VideoSection[] = [];
}
